import { useEffect, useState, type MutableRefObject } from "react";
import type { ChatMessage, PairingClient } from "../protocol";

/** The selected group's message thread. `selectedGroup` is "pairingId/groupId". Resubscribes on change. */
export function useGroupThread(
  clients: MutableRefObject<Map<string, PairingClient>>,
  selectedGroup: string | null,
  /** From useSessions — re-runs the subscription once the client for this group exists (see useSessions). */
  clientsVersion: number,
): ChatMessage[] {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  useEffect(() => {
    if (!selectedGroup) {
      setMessages([]);
      return;
    }
    const [pid, gid] = selectedGroup.split("/");
    const unsub = clients.current.get(pid)?.subscribeGroupMessages(gid, setMessages);
    return () => unsub?.();
  }, [selectedGroup, clientsVersion]);
  return messages;
}
